export default __webpack_public_path__ + "static/media/yuri.fd79f17d.webp";